module.exports = __webpack_public_path__ + "static/media/iphones-white-image.0f06443b.png";